'use client';

import Link from 'next/link';
import Image from 'next/image';
import { ArrowLeft, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-indigo-100 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        {/* Logo */}
        <div className="flex items-center justify-center mb-8">
          <Image
            src="/brand/delfin-logo-full.svg"
            alt="Delfin"
            width={200}
            height={40}
            priority
            className="h-8 w-auto dark:hidden"
          />
          <Image
            src="/brand/delfin-logo-full-ivory.svg"
            alt="Delfin"
            width={200}
            height={40}
            priority
            className="h-8 w-auto hidden dark:block"
          />
        </div>
        
        {/* 404 Error */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-primary mb-4">404</h1>
          <h2 className="text-2xl font-bold text-foreground mb-2">Page not found</h2>
          <p className="text-muted-foreground">
            Sorry, we couldn't find the page you're looking for.
          </p>
        </div>
        
        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            href="/"
            className="bg-primary-600 hover:bg-primary-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center"
          >
            <Home className="h-4 w-4 mr-2" />
            Go home
          </Link>
          <Button
            variant="outline"
            onClick={() => window.history.back()}
            className="h-auto border-2 border-input hover:border-input text-foreground bg-transparent hover:bg-transparent shadow-none px-6 py-3 rounded-lg font-semibold"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go back
          </Button>
        </div>
        
        {/* Help Text */}
        <div className="mt-8 text-sm text-muted-foreground">
          <p>
            If you believe this is an error, please{' '}
            <a href="mailto:support@aiforcsm.com" className="text-primary hover:text-primary font-medium">
              contact support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
